// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#send-message-template-list[data-v-234634ca]{max-width:1280px;margin-left:auto;margin-right:auto}#send-message-template-list .add-btn[data-v-234634ca],#send-message-template-list .back-btn[data-v-234634ca]{width:80px}#send-message-template-list .add-btn[data-v-234634ca]{margin-right:12px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
